import { useTranslation } from 'react-i18next'
import React from 'react'
import { COLORS } from '@btime/constants'

import Message from './Message'
import { useNavigation } from '../../utils/contexts/NavigationContext'
import { useNewFeature } from '../../utils/contexts/NewFeature'

const ProcessesFeatureMessage = () => {
  const { t } = useTranslation('components')
  const navigate = useNavigation()
  const { isActive, toggleFeature, isAllowedToUse } = useNewFeature('PROCESSES')

  if (!isAllowedToUse) return null

  const actionLabel = isActive ? t('processesMessage.backToPreviousVersion') : t('processesMessage.activateNewVersion')
  const title = isActive ? t('processesMessage.newFeatureActivated') : t('processesMessage.discoverNewFeature')
  const message = isActive ? t('processesMessage.enjoyNewFeature') : t('processesMessage.viewAndManageByProcess')
  const bgColor = isActive ? COLORS.green : COLORS.purple
  const actionColor = isActive ? COLORS.black : COLORS.white

  const handleAction = () => {
    toggleFeature()
    !isActive ? navigate('/processes') : navigate('/')
  }

  return (
    <Message
      noRadius
      title={title}
      icon="IoFlask"
      iconSize={2}
      message={message}
      color={actionColor}
      bgColor={bgColor}
      useMarkdown
      actionLabel={actionLabel}
      actionColor={actionColor}
      action={handleAction}
    />
  )
}

export default ProcessesFeatureMessage
